<div style="margin-right: 32px;">
    <div>
        <h4 class="title" style="margin-top: 15px;">Configuration Page</h4>
    </div>
</div>
<div class="card-box" style="margin: 2px;padding-bottom: 15px;margin-bottom: 30px;">

    <div class="row">
        <div class="col-md-12">
            <h5 class="form-lable" style="font-weight: 600;width: 100px;font-size: 12px;float: left;padding-top: 10px;">
                Select User:</h5>
            <select style="margin-top: 10px;">
                <option>Select</option>
                <option>Personal Loan</option>
                <option>Auto Loan</option>
                <option>Credit Cards</option>
                <option>Sales Finance</option>
            </select>
            <h5 class="form-lable" style="font-size: 12px;padding-top: 10px;">All Fields:</h5>
        </div>
        <div class="col-md-4">
            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike">
            <label for="vehicle1"> Item-001</label><br>
            <input type="checkbox" id="vehicle2" name="vehicle1" value="Bike">
            <label for="vehicle2"> Item-002</label><br>
            <input type="checkbox" id="vehicle3" name="vehicle1" value="Bike">
            <label for="vehicle3"> Item-003</label><br>
            <input type="checkbox" id="vehicle4" name="vehicle1" value="Bike">
            <label for="vehicle4"> Item-004</label><br>
        </div>
        <div class="col-md-4">
            <input type="checkbox" id="vehicle5" name="vehicle1" value="Bike">
            <label for="vehicle5"> Item-005</label><br>
            <input type="checkbox" id="vehicle6" name="vehicle1" value="Bike">
            <label for="vehicle6"> Item-006</label><br>
            <input type="checkbox" id="vehicle7" name="vehicle1" value="Bike">
            <label for="vehicle7"> Item-007</label><br>
            <input type="checkbox" id="vehicle8" name="vehicle1" value="Bike">
            <label for="vehicle8"> Item-008</label><br>
        </div>
        <div class="col-md-4">
            <input type="checkbox" id="vehicle5" name="vehicle1" value="Bike">
            <label for="vehicle5"> Item-005</label><br>
            <input type="checkbox" id="vehicle6" name="vehicle1" value="Bike">
            <label for="vehicle6"> Item-006</label><br>
            <input type="checkbox" id="vehicle7" name="vehicle1" value="Bike">
            <label for="vehicle7"> Item-007</label><br>
            <input type="checkbox" id="vehicle8" name="vehicle1" value="Bike">
            <label for="vehicle8"> Item-008</label><br>
        </div>
    </div>

</div>
<div class="card-box" style="margin: 2px;padding-bottom: 15px;">
    <div class="row">
        <div class="col-md-12">
            <h5 class="form-lable" style="font-weight: 600;width: 100px;font-size: 12px;float: left;padding-top: 10px;">
                Selected Items:</h5>
            <!-- <select style="margin-top: 10px;">
                <option>Select</option>
                <option>Personal Loan</option>
                <option>Auto Loan</option>
                <option>Credit Cards</option>
                <option>Sales Finance</option>
            </select> -->
        </div>
        <div class="col-md-4">

            <label for="vehicle1"> Item-001</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle2"> Item-002</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle3"> Item-003</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle4"> Item-004</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

        </div>
        <div class="col-md-4">

            <label for="vehicle5"> Item-005</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle6"> Item-006</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle7"> Item-007</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle8"> Item-008</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

        </div>
        <div class="col-md-4">

            <label for="vehicle5"> Item-005</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle6"> Item-006</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle7"> Item-007</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

            <label for="vehicle8"> Item-008</label><i class="fa fa-times-circle-o" aria-hidden="true"
                style="font-size: 19px;margin: 3px;color: #D32F2F;"></i><br />

        </div>
    </div>

</div>
<div class="row" style="margin-top: 30px;">
    <div class="col-md-12">
        <button class="btn btn-primary" style="margin-right: 10px;">Save</button>

        <button class="btn btn-primary" style="margin-right: 10px;">Update</button>

        <button class="btn btn-primary" style="margin-right: 10px;">Reset</button>

    </div>
</div>